export default __webpack_public_path__ + "static/30-d1aa0d9f931c8e130aeb3538186b8ee2.jpg";